import { initAccordions } from "./modules/accordion.mjs";
import { handleContactFormSubmit } from "./modules/contact-form.mjs";
import { initFactsSliders } from "./modules/facts-slider.mjs";
import { handleResponsiveVideos } from "./modules/handleResponsiveVideos.mjs";
import { initHeroSlider } from "./modules/hero-slider.mjs";
import { initNewsTeaser } from "./modules/news-teaser.mjs";
import { initTeaserSliders, initTeaserSlidersV2, initTeaserSlidersV3, teaserSliderTextAnimation } from "./modules/teaser-slider.mjs";
import { handleVideoBanner, handleAutoplayingVideoBanner, initVideoBannerSlider } from "./modules/video-banner.mjs";
import { initImageTextBlockSlider } from "./modules/initImageTextBlockSlider.mjs";
import { handleMainMenu } from "./modules/main-menu.mjs";
import { handleFullscreenMedia } from "./modules/fullscreen-media.mjs";
import { contactBlockFiltering } from "./modules/contact-block-filtering.mjs"
import { filterDownloadMedia } from "./modules/media-downloads-filtering.mjs";
import { handleMediaDownloadVideoPlayback } from "./modules/handleMediaDownloadVideos.mjs";
import { handleScrollIntoViewAnimation } from "./modules/scrollIntoViewAnimation.mjs";
import { animateTextBlock } from "./modules/textBlockAnimation.mjs";
import { filterTeaserItems } from "./modules/filterTeaserItemsBlock.mjs";
import { handleApplicationFormSubmit } from "./modules/application-form.mjs";
import { searchPage } from "./modules/search.mjs";
import { smartRecruiters } from "./modules/smart-recruiters.mjs";
import { teaserBlockAnimation } from "./modules/teaserBlockAnimation.mjs";
import { initImageTextSlider } from "./modules/image-text-slider.mjs";
import { initWorlMap } from "./modules/world-map.mjs";

initHeroSlider();
initTeaserSliders();
initTeaserSlidersV2();
initTeaserSlidersV3();
initAccordions();
initFactsSliders();
handleResponsiveVideos();
handleVideoBanner();
handleAutoplayingVideoBanner();
initVideoBannerSlider();
initNewsTeaser();
handleContactFormSubmit();
initImageTextBlockSlider();
handleMainMenu();
handleFullscreenMedia();
contactBlockFiltering();
filterDownloadMedia();
handleMediaDownloadVideoPlayback();
filterTeaserItems();
handleApplicationFormSubmit();
searchPage();
animateTextBlock();
teaserBlockAnimation();
teaserSliderTextAnimation();
initImageTextSlider();
initWorlMap();

smartRecruiters();


// Always call this function at the end of your JavaScript file
handleScrollIntoViewAnimation();